import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useUser } from './UserContext';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faUsers, faChartLine, faSignOutAlt, faBars, faDna, faSoap, faHandsBubbles, faHouseFloodWater, faWater, faMicroscope, faFilePdf, faCloud, faCloudUpload, faFilePowerpoint, faFile, faFileAlt, faVialCircleCheck, faGear, faVials, faVial, faComments, faCircleNodes, faExplosion, faMagic, faCircleH, faGlobe, faRing, faLifeRing, faCircleNotch, faLayerGroup, faPeopleLine, faArrowsDownToPeople, faPerson, faFileShield, faFileArchive, faFileCircleCheck, faFileClipboard, faFileExport, faFileMedicalAlt, faFileMedical, faFileImport, faFileWaveform, faFileCode, faNewspaper, faProcedures, faUserDoctor, faQuestionCircle, faBoxOpen } from '@fortawesome/free-solid-svg-icons';
import Homepage from './HomePage';
import Patients from './Patients';
import Analytics from './Analytics';
import Discoveromics from './discoveromics/Discoveromics.js';
import ReportGenerator from './ReportGenerator/ReportGenerator.js';
import ReportGen from './ReportGenerator2/ReportGen.js';
import Image from './image.js';
import InvitePatients from './Invitepatients';
import SettingsModal from './SettingsModal';
import './Dashboard.css';

import logo from './UltimateHome/components/CardContent/SZAPortal/logo (4).png';
import ProjectManager from './ProjectManager/ProjectManager';
import LabMain from './LabManager/LabMain/LabMain.js';
import Settings from './Settings/Settings';
import OmicAtlas from './OmicAtlas/OmicAtlas';
import Sample from './SampleManager/Sample';
import NotificationBell from './PortalTools/NotificationBell';
import Clinician from './clinician/clinician.js';

function Dashboard() {
    const navigate = useNavigate();
    const { user, clearUser, refreshUserData } = useUser();
    const [selectedTab, setSelectedTab] = useState('metaupload');
    const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);
    const [isSettingsModalOpen, setIsSettingsModalOpen] = useState(false);
    const [pageTransition, setPageTransition] = useState(false);
    const initialLoadRef = useRef(false);

    useEffect(() => {
        if (!user) {
            navigate('/login');
        } else if (!initialLoadRef.current && user.id) {
            // Only refresh once when first mounting with a valid user
            initialLoadRef.current = true;
            refreshUserData();
            console.log('[Dashboard] Initial user data refresh triggered');
        }
    }, [user, navigate, refreshUserData]);

    useEffect(() => {
        setPageTransition(true);
        const timer = setTimeout(() => {
            setPageTransition(false);
        }, 300);
        return () => clearTimeout(timer);
    }, [selectedTab]);

    if (!user) {
        return null;
    }

    const handleLogout = () => {
        // Use the clearUser function from UserContext to properly clean up the user state
        clearUser();
        navigate('/');
        console.log('[Dashboard] Logout completed, navigating to home');
    };

    const closeAddUserModal = () => {
        setIsAddUserModalOpen(false);
    };

    const closeSettingsModal = () => {
        setIsSettingsModalOpen(false);
    };

    const renderAddUserModal = () => {
        return (
            <div className={`addusermodal ${isAddUserModalOpen ? 'open' : ''}`}>
                <div className="addusercontent">
                    <div className="adduserclose" onClick={closeAddUserModal}>✖</div>
                    <InvitePatients />
                </div>
            </div>
        );
    };

    const renderSettingsModal = () => {
        return (
            <div className={`addusermodal ${isSettingsModalOpen ? 'open' : ''}`}>
                <div className="settingaddusercontent">
                    <SettingsModal user={user} closeSettingsModal={closeSettingsModal} />
                </div>
            </div>
        );
    };

    const toggleSettingsModal = () => {
        setIsSettingsModalOpen(!isSettingsModalOpen);
    };

    const toggleAddUserModal = () => {
        setIsAddUserModalOpen(!isAddUserModalOpen);
    };

    const handleTabChange = (tabName) => {
        setPageTransition(true);
        setSelectedTab(tabName);
    };

    const getNavItemClass = (tabName) => {
        return `nav-item ${selectedTab === tabName ? 'selected' : ''}`;
    };

    return (
        <div className="dashboard-container">
            {isAddUserModalOpen && renderAddUserModal()}
            {isSettingsModalOpen && renderSettingsModal()}

            <div className="sidebar">
                <div className="logo">
                    <img src={logo} alt="Logo" onClick={() => navigate('/')} style={{ cursor: 'pointer' }} />
                </div>
                <ul>

                    <li className={getNavItemClass('metaupload')} onClick={() => handleTabChange('metaupload')}>
                        <FontAwesomeIcon icon={faLayerGroup} className="outline-icon" />
                    </li>
                          {(user?.role === 'Admin+' || user?.role === 'Reviewer') && (

                    <li className={getNavItemClass('clinician')} onClick={() => handleTabChange('clinician')}>
                        <FontAwesomeIcon icon={faUserDoctor} className="outline-icon" />
                    </li>

)}
                    {(user?.role === 'Admin+') && (
                    <li className={getNavItemClass('samplemanager')} onClick={() => handleTabChange('samplemanager')}>
                        <FontAwesomeIcon icon={faBoxOpen} className="outline-icon" />
                    </li>
                    )}
                    <li className={getNavItemClass('reportgen')} onClick={() => handleTabChange('reportgen')}>
                        <FontAwesomeIcon icon={faFile} className="outline-icon" />
                    </li>
                    <li className={getNavItemClass('patients')} onClick={() => handleTabChange('patients')}>
                        <FontAwesomeIcon icon={faUsers} className="outline-icon" />
                    </li>
                    {(user?.role === 'Admin++') && (

                    <li className={getNavItemClass('omicatlas')} onClick={() => handleTabChange('omicatlas')}>
                        <FontAwesomeIcon icon={faCircleNotch} className="outline-icon" />
                    </li>   

)}


                    {(user?.role === 'Admin++') && (
                        <li className={getNavItemClass('analytics')} onClick={() => handleTabChange('analytics')}>
                            <FontAwesomeIcon icon={faChartLine} className="outline-icon" />
                        </li>
                    )}

                    <li className={getNavItemClass('discoveromics')} onClick={() => handleTabChange('discoveromics')}>
                        <FontAwesomeIcon icon={faMicroscope} className="outline-icon" />
                    </li>

                 

           
                    <li className={getNavItemClass('settings')} onClick={() => handleTabChange('settings')}>
                        <FontAwesomeIcon icon={faGear} className="outline-icon" />
                    </li>

                    {(user?.role === 'image') && (
                        <li className={getNavItemClass('image')} onClick={() => handleTabChange('image')}>
                            <FontAwesomeIcon icon={faChartLine} className="outline-icon" />
                        </li>
                    )}
                </ul>
                <div className="notification-bell">
                    <FontAwesomeIcon icon={faSignOutAlt} onClick={handleLogout} className="outline-icon" />
                </div>
            </div>

            <div className="main-content fade-in">
                <div className="top-bar">
                    <div className="hey-bar">
                        <div className="binitials-circle">
                            {user?.firstName?.[0].toUpperCase()}{user?.lastName?.[0].toUpperCase()}
                        </div>
                        <div className="text-container">
                            <span className="greeting">Hello,</span>
                            <span className="name">{user?.firstName} {user?.lastName}</span>
                        </div>
                        <div className="notification-container">
                            <NotificationBell userId={user?.id} />
                        </div>
                        {user?.role === 'Reviewer' && (
                            <a
                                href="https://xiyasong.github.io/Genomics_platform/GenRiskPro_Dashboard_tutorial/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="help-button"
                            >
                                <FontAwesomeIcon icon={faQuestionCircle} />
                                <span>Help</span>
                            </a>
                        )}
                    </div>
                </div>
                <div className={`content-area ${pageTransition ? 'page-transition' : ''}`}>
                    {selectedTab === 'homepage' && <Homepage user={user} />}
                                        {selectedTab === 'clinician' && <Clinician user={user} />}

                    {selectedTab === 'analytics' && <Analytics user={user} />}
                    {selectedTab === 'patients' && <Patients user={user} />}
                    {selectedTab === 'image' && <Image user={user} />}
                    {selectedTab === 'discoveromics' && <Discoveromics user={user} />}
                    {selectedTab === 'metaupload' && <ProjectManager user={user} />}
                    {selectedTab === 'reportgen' && <ReportGen user={user} />}
                    {selectedTab === 'labmain' && <LabMain user={user} />}
                    {selectedTab === 'settings' && <Settings user={user} />}
                    {selectedTab === 'omicatlas' && <OmicAtlas user={user} />}
                    {selectedTab === 'samplemanager' && <Sample user={user} />}
                </div>
            </div>
            <style jsx>{`
                @keyframes pageTransitionAnim {
                    0% { opacity: 0; }
                    100% { opacity: 1; }
                }
                .page-transition {
                    animation: pageTransitionAnim 0.3s ease-in-out;
                }
            `}</style>
        </div>
    );
}

export default Dashboard;
